import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "rig";

export const getRigList = async (filter: any = {}) => {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: { filter: JSON.stringify(filter) },
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		throw new Error(error.response.data.error);
	}
};

export const addRigItem = (data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${apiURL}`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				console.log("error", e);
				reject(e);
			});
	});
};

export const updateRigItem = (uuid: string, data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${apiURL}`,
				{
					filter: { _id: uuid },
					data: data,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteRigItem = (uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${apiURL}`, {
				params: {
					filter: JSON.stringify({ _id: uuid }),
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
